import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userInfo: null,
    captainData: null,
    isAuthLoading: true,
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        clearUserInfo: (state) => {
            state.userInfo = null;
        },
        setCaptainData: (state, action) => {
            state.captainData = action.payload;
        },
        clearCaptainData: (state) => {
            state.captainData = null;
        },
        setAuthLoading: (state, action) => {
            state.isAuthLoading = action.payload;
        },
    },
});

export const { setUserInfo, clearUserInfo, setCaptainData, clearCaptainData, setAuthLoading } = userSlice.actions;

export default userSlice.reducer;
